<template>
  <v-container>
    <v-layout align-center justify-center column>
      <v-flex xs12 sm8 md4>
        <v-card class="elevation-12">
          <v-toolbar color="secondary">
            <v-toolbar-title>Signup for a FilmID password</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-form>
              <v-text-field
                type="text"
                prepend-icon="person"
                class="pa-0"
                v-model="email"
                :rules="emailRules"
                name="email"
                id="email">
              </v-text-field>
              <v-text-field
                prepend-icon="lock"
                label="password"
                type="password"
                v-model="password"
                name="password"
                id="password"
                :rules="passwordRules"
                :append-icon="visibility.password"
                @click:append="toggleVisibility('password')"
                ref="password"
                autocomplete="new-password"
                >
              </v-text-field>
              <v-text-field
                prepend-icon="lock"
                label="re-enter password"
                type="password"
                v-model="verifyPassword"
                name="verify-password"
                id="verify-password"
                :rules="verifyPasswordRules"
                :append-icon="visibility.verifyPassword"
                @click:append="toggleVisibility('verifyPassword')"
                ref="verifyPassword"
                autocomplete="new-password"
              ></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions class="justify-center">
            <v-btn color="primary" @click="signupClick" :disabled="signupDisabled">Signup</v-btn>
            <v-btn color="secondary" @click="cancelClick">Cancel</v-btn>
          </v-card-actions>
      </v-card>
      <v-card v-if="showVerificationDialog">
        <v-toolbar light color="accent">
          <v-toolbar-title>Verify your email address</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon>
            <v-icon @click="showVerificationDialogCancel">cancel</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          An email has been sent to {{ email }}
          <br />
          Please follow the instructions to verify that you own
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</v-container>
</template>

<script>

import { Controls } from '@/gql'
import { mergeControls } from '@/js/apollo'
export default {
  name: 'Signup',
  props: {
    auth: Object
  },
  computed: {
    signupDisabled () {
      return !(/.+@.+/.test(this.email) && this.password.length > 5 && this.password === this.verifyPassword)
    },
    showVerificationDialog () {
      return this.Controls && this.Controls.showVerificationDialog
    }
  },
  data () {
    return {
      email: '',
      password: '',
      verifyPassword: '',
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+/.test(v) || 'E-mail must be valid'
      ],
      visibility: {
        password: 'visibility',
        verifyPassword: 'visibility'
      },
      Controls: {},
      verifyPasswordRules: [
        v => (v === this.password || !v) || 'Passwords must match'
      ],
      passwordRules: [
        v => v.length > 7 || 'Passwords must be at least 8 characters'
      ]
    }
  },
  mounted () {
    // make sure passwords are hidden
    this.toggleVisibility('password', 'password')
    this.toggleVisibility('verifyPassword', 'password')
  },
  methods: {
    toggleVisibility (name, force) {
      //  flip the append icon as well as the type of the input control
      const { $el } = this.$refs[name]
      if (!$el) {
        console.log('missing ref ', name)
      } else {
        const input = $el.querySelector('input')
        if (!input) {
          console.log('could not find input for ', name)
        } else {
          force = force || (input.getAttribute('type') === 'password' ? 'text' : 'password')
          this.visibility[name] = force === 'password' ? 'visibility' : 'visibility_off'
          input.setAttribute('type', force)
        }
      }
    },
    clearShows () {
      mergeControls({
        showVerificationDialog: false
      })
    },
    showVerificationDialogCancel () {
      this.clearShows()
    },
    goBack () {
      // this.$router.replace({ path: this.Controls.routerFrom })
    },
    async forgotPassword () {
      await this.$auth.forgotPassword({
        email: this.email
      })
    },
    async signupClick () {
      await this.$auth.create({
        service: 'password',
        email: this.email,
        password: this.password
      })
      this.goBack()
    },
    cancelClick () {
      this.clearShows()
      this.goback()
    }
  },
  apollo: {
    Controls: {
      query: Controls
    }
  }
}
</script>
